<template>
  <li>
    <div class="row">
      <div class="col-12 col-sm-12 col-lg-12 col-xl-7">
        <div class="form-group mb-0">
          <span class="control-label d-xl-none">Capability Name</span>
          <p class="form-control-plaintext" :class="{ 'strong': capability.focus }">
            {{ capability.name }} {{ capability.focus ? '(Focus)' : '' }}
          </p>
        </div><!-- /.form-group -->
      </div>

      <div class="col-12 col-sm-6 col-lg-3 col-xl-2">
        <div class="form-group mb-0">
          <span class="control-label d-xl-none">Level</span>
          <p class="form-control-plaintext" :class="{ 'strong': capability.focus }">
            {{ capabilityLevel }}
          </p>
        </div><!-- /.form-group-->
      </div>

      <div class="col-12 col-sm-12 col-lg-5 col-xl-3">
        <div class="form-group mb-0">
          <span class="control-label d-xl-none">Initial Setting</span>
          <multiselect
            v-model="resultSelected"
            name="result"
            v-validate.disable="'required'"
            :data-vv-scope="`capability-${capabilityId}`"
            :class="[errorClass(`result`, `capability-${capabilityId}`), validClass(`result`, `capability-${capabilityId}`)]"
            placeholder="Please select..."
            track-by="value"
            label="text"
            :options="resultOptions"
            :show-labels="false"
            :searchable="false"
          />
        </div><!-- /.form-group -->
      </div>
    </div><!-- /.row -->
  </li>
</template>

<script>
import { stateMapper } from 'mixins/capabilities'
import { startCase } from 'lodash'
import Multiselect from 'vue-multiselect'
import { graduateComputed } from 'vx/helpers'

export default {
  inject: ['$validator'],

  mixins: [stateMapper],

  props: {
    capability: {
      required: true,
      type: Object
    }
  },

  components: {
    Multiselect
  },

  computed: {
    ...graduateComputed,

    resultOptions () {
      return [
        {
          value: 'strength',
          text: this.strengthText
        },
        {
          value: 'meets',
          text: 'Meets'
        },
        {
          value: 'requires_development',
          text: 'Requires development'
        },
        {
          value: 'not_observed',
          text: 'Not observed'
        }
      ]
    },

    /**
     * Get and set the selected role
     */
    resultSelected: {
      get () {
        return this.resultOptions.find(option => option.value === this.capability.result)
      },

      set (option) {
        this.stateResult = option.value
      }
    },

    capabilityId () {
      return this.capability.id
    },

    capabilityLevel () {
      return startCase(this.capability.level)
    }
  }
}
</script>
